import { FC, useContext } from "react";

import { AuthContext } from "../../../contexts/AuthContext";

import { useMediaQuery } from "@mui/material";

import Avatar from "../../../components/Avatar";
import styles from "./styles.module.scss";
import Infos from "./Infos";
import Security from "./Security";
import { Select } from "../../../components/OldSelect";

type Props = {
    handleTabChange: (key: string) => void;
}

const Profil: FC<Props> = ({ handleTabChange }) => {
    const { getNameInitials, getName } = useContext(AuthContext)!;

    const isMobile = useMediaQuery("(max-width: 1050px)");

    return (
        <div className={styles.account_form}>
            <div className={styles.header}>
                {isMobile ? (
                    <Select
                        className={styles.selectTab}
                        onChanged={(value) => {
                            const key = value as string;
                            handleTabChange(key === "profil" ? "" : key);
                        }}
                    >
                        <option value="profil">Profil</option>
                        <option value="questions">Informations</option>
                        <option value="affichage">Affichage</option>
                    </Select>
                ) : (
                    <span className={styles.account_form_header}>Profil</span>
                )}
            </div>
            <div className={styles.account_sections}>
                {!isMobile && (
                    <div className={styles.account_section}>
                        <Avatar
                            color="#479DD4"
                            label={getNameInitials()}
                            size={74}
                        />
                        <span className={styles.account_form_name}>
                            {getName()}
                        </span>
                    </div>
                )}
                <div className={styles.account_section}>
                    <Infos />
                </div>
                <div className={styles.account_section}>
                    <Security />
                </div>
            </div>
        </div>
    );
};

export default Profil;
